module.exports = seal => seal.substring(0, seal.length - 1)
